import { patientsTextFilter } from "./PatientsContext";

export const PatientsContextProvider = patientsTextFilter.Provider;
export const PatientsFilterInput = patientsTextFilter.FilterInput;
